import angular from 'angular';
import _ from 'lodash';
import template from './searchMyCandidatesView.html';
import logger from '../../shared/logger';
import './style.scss';
import { RECRUITER_WORKFLOW_STATUS } from '../recruiter/constants/recruiter-workflow';

const SEARCH_DATA_TYPES = {
    RECRUITER: 'recruiter',
    TALENYA: 'talenya',
    EMPLOYER: 'employer',
};

const SEARCH_PARAMS_BY_TYPE = {
    [SEARCH_DATA_TYPES.RECRUITER]: 'recruiterId',
    [SEARCH_DATA_TYPES.EMPLOYER]: 'employerId',
    [SEARCH_DATA_TYPES.TALENYA]: 'recruiterId',
};

export class SearchMyCandidatesComponent {
    /* @ngInject */
    constructor(CandidateService, $timeout, $state, RouteService, $localStorage, EnvSettings, WebAppRouteService) {
        this.$localStorage = $localStorage;
        this.$timeout = $timeout;
        this.$state = $state;
        this.CandidateService = CandidateService;
        this.RouteService = RouteService;
        this.EnvSettings = EnvSettings;
        this.WebAppRouteService = WebAppRouteService;
    }

    $onInit() {
        this.candidatesData = [];
        this.requestData = {
            matchPhrase: '',
            searchLimit: this.RouteService.getSystemDefaults('searchMyCandidateLimit') || 10,
        };


        if (this.searchData.type === SEARCH_DATA_TYPES.TALENYA) {
            this.requestData.allCandidates = true;
        } else {
            const searchField = SEARCH_PARAMS_BY_TYPE[this.searchData.type];
            this.requestData[searchField] = this.searchData.entityId;
        }
    }

    openCandidatePage(candidate) {
        if (candidate.workflowRecruiterStatus === RECRUITER_WORKFLOW_STATUS.HIDDEN) {
            this.$localStorage.searchShowOption = {
                showAll: true,
                showActive: false,
            };
            candidate.workflowRecruiterStatus = RECRUITER_WORKFLOW_STATUS.PROSPECT;
        }

        const stateName = this.searchData.type === SEARCH_DATA_TYPES.EMPLOYER ? 'employer.candidatesJob' : 'recruiter.candidatesJob';
        const stateParams = {
            positionId: candidate.positionId,
            talentID: candidate.talentId,
            currCandidatePage: 1,
        };

        if (this.searchData.type === SEARCH_DATA_TYPES.EMPLOYER) {
            const entityFieldName = SEARCH_PARAMS_BY_TYPE[SEARCH_DATA_TYPES.EMPLOYER];
            stateParams.workflowStep = candidate.workflowEmployerStatus;
            stateParams[entityFieldName] = this.searchData.entityId;
        } else {
            const entityFieldName = SEARCH_PARAMS_BY_TYPE[SEARCH_DATA_TYPES.RECRUITER];
            stateParams.workflowStep = candidate.workflowRecruiterStatus;
            stateParams[entityFieldName] = this.requestData[entityFieldName] || candidate[entityFieldName];
        }

        if (stateName === 'employer.candidatesJob') {
            return this.WebAppRouteService.goToEmployerCandidatesPage(stateParams);
        } else {
            this.$state.go(stateName, stateParams);
        }

        this.clearCandidatesList();
    }

    clearCandidatesList() {
        this.candidatesData.length = 0;
    }

    clearMatchPhrase() {
        this.requestData.matchPhrase = '';
        this.clearCandidatesList();
    }

    matchPhraseChange() {
        if (this.requestTimeout) {
            this.$timeout.cancel(this.requestTimeout);
        }

        this.requestTimeout = this.$timeout(() => {
            if (this.requestData.matchPhrase && this.requestData.matchPhrase.length > 1) {
                this.CandidateService.getCandidates(this.requestData)
                    .then(({ result: foundCandidates }) => {
                        this.candidatesData = _.map(foundCandidates, (candidate) => {
                            if (!candidate.name) {
                                return candidate;
                            }

                            if (candidate.name === this.requestData.matchPhrase) {
                                candidate.newName = [
                                    {
                                        text: candidate.name,
                                        match: true,
                                    },
                                ];
                                return candidate;
                            }

                            if (candidate.name) {
                                const regex = new RegExp(this.requestData.matchPhrase, 'gi');
                                const indices = [];
                                let result;

                                while ((result = regex.exec(candidate.name))) {
                                    indices.push(result.index);
                                }

                                let newName = '';
                                let index = 0;
                                for (let i = 0; i < indices.length; i++) {
                                    if (index <= indices[i] - 1) {
                                        newName += candidate.name.slice(index, indices[i]);
                                    }

                                    newName = `${newName}<span style="color: #737373;">${candidate.name.slice(indices[i], indices[i] + this.requestData.matchPhrase.length)}</span>`;
                                    index = indices[i] + this.requestData.matchPhrase.length;
                                }
                                if (index < candidate.name.length - 1) {
                                    newName += candidate.name.slice(index, candidate.name.length);
                                }

                                candidate.name = newName;
                            }
                            return candidate;
                        });
                    })
                    .catch(err => logger.error(err));
            }
        }, 200);
    }
}

export const SearchMyCandidatesComponentConfiguration = {
    template,
    bindings: {
        searchData: '<',
    },
    controller: SearchMyCandidatesComponent,
    controllerAs: 'searchMyCandidatesCtrl',
};

angular
    .module('TALENYA-FE')
    .component('searchMyCandidatesComponent', SearchMyCandidatesComponentConfiguration);
